import { createSlice } from '@reduxjs/toolkit';
import { calculatingFeeTask } from './actions';

const initialState = {
  data: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const calculateFeeTask = createSlice({
  name: 'calculateFeeTask',
  initialState,
  reducers: {
    // reducers goes here
    resetCalculateFeeTask: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(calculatingFeeTask.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(calculatingFeeTask.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(calculatingFeeTask.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export const { resetCalculateFeeTask } = calculateFeeTask.actions;

export default calculateFeeTask.reducer;
